class DomUtils {
  static getScrollableParent(
    element: HTMLElement,
    includeHidden?: boolean,
  ): HTMLElement | Window {
    let style = getComputedStyle(element);
    const excludeStaticParent = style.position === "absolute";
    const overflowRegex = includeHidden
      ? /(auto|scroll|hidden)/
      : /(auto|scroll)/;

    if (style.position === "fixed") {
      return window;
    }
    type ParentType = HTMLElement | null;
    for (let parent: ParentType = element; (parent = parent.parentElement); ) {
      style = getComputedStyle(parent);
      if (excludeStaticParent && style.position === "static") {
        continue;
      }
      if (
        overflowRegex.test(style.overflow + style.overflowY + style.overflowX)
      ) {
        const htmlEl: any = parent;
        return htmlEl;
      }
    }

    return window;
  }

  static isElementInViewport(el: HTMLElement, scrollableParent: any): boolean {
    const rect = el.getBoundingClientRect();
    const scrollableRect = scrollableParent.getBoundingClientRect
      ? scrollableParent.getBoundingClientRect()
      : {
          top: 0,
          left: 0,
          bottom: scrollableParent.innerHeight
            ? scrollableParent.innerHeight
            : window.innerHeight,
          right: scrollableParent.innerWidth
            ? scrollableParent.innerWidth
            : window.innerWidth,
        };

    return (
      rect.top + rect.height >= scrollableRect.top &&
      rect.left >= scrollableRect.left &&
      rect.bottom - rect.height <= scrollableRect.bottom &&
      rect.right <= scrollableRect.right
    );
  }

  static getEventPath(event: Event): HTMLElement[] {
    const path = [];
    let node = event.target as HTMLElement | null;
    while (node !== document.body && node?.parentNode) {
      path.push(node);
      node = node.parentNode as HTMLElement | null;
    }

    return path;
  }

  /**
   * Copies specified text to clipboard
   * @param {string} text The text to copy
   * @return True if successful, false otherwise
   */
  static copyTextToClipboard(text: string): boolean {
    const textArea = document.createElement("textarea");
    textArea.style.position = "fixed";
    textArea.style.top = "0";
    textArea.style.left = "0";
    textArea.style.width = "2em";
    textArea.style.height = "2em";
    textArea.style.padding = "0";
    textArea.style.border = "none";
    textArea.style.outline = "none";
    textArea.style.boxShadow = "none";
    textArea.style.background = "transparent";

    textArea.value = text;

    if (document.body) document.body.appendChild(textArea);

    textArea.select();

    let successful;

    try {
      successful = document.execCommand("copy");
    } catch (e) {
      successful = false;
    } finally {
      if (document.body) document.body.removeChild(textArea);
    }
    return successful;
  }

  static downloadAsTextFile(text: string, filename: string) {
    const href = `data:text/json;charset=utf-8,${encodeURIComponent(text)}`;
    const downloadAnchorNode = document.createElement("a");
    downloadAnchorNode.setAttribute("href", href);
    downloadAnchorNode.setAttribute("download", filename);
    if (document.body) {
      document.body.appendChild(downloadAnchorNode); // required for firefox
    }
    downloadAnchorNode.click();
    downloadAnchorNode.remove();
  }

  static jsonSyntaxHighlight(json: any) {
    const newJson = json
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;");
    return newJson.replace(
      /("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+-]?\d+)?)/g,
      (match: any) => {
        let cls = "number";
        if (/^"/.test(match)) {
          if (/:$/.test(match)) {
            cls = "key";
          } else {
            cls = "string";
          }
        } else if (/true|false/.test(match)) {
          cls = "boolean";
        } else if (/null/.test(match)) {
          cls = "null";
        }
        return `<span class="${cls}">${match}</span>`;
      },
    );
  }
}

export default DomUtils;
